import type { DirectoryIdentifier } from '@/api/types';

export function identifierDisplayValue(
  references: readonly DirectoryIdentifier[] | undefined,
  fallbackIds: readonly string[],
): string {
  return (references && references.length > 0 ? references.map((reference) => reference.displayName) : fallbackIds).join(', ');
}
